import React from "react"

import { Container } from "@material-ui/core"

import { Link } from "gatsby"


export default function CTA({ children }) {  
  return (
    <>
    <Container>
    <div className="gradient-bar"></div>
    <br/>
    </Container>
      <section className="cta">
        <Container>
        <p className="large" style={{display: 'none'}}>
        {children}
        </p>
        <p className="large">To know more get in touch with us</p>
        <br/>
        <Link to="/contact-us" className="btn">
          <span>
          Get In Touch
          </span>
        </Link>
        </Container>
        <br/>
      </section>
      </>

  )
}
